export default () => window.location.search.includes("page-builder")
